import { SERVER_HOST, handleResponse } from "@api";
import axios from "axios";

export async function getCollection(
  showcase_id: number
) {
  if (showcase_id > 0 && !isNaN(showcase_id)) {
    const collection = await axios.get(`${SERVER_HOST}/api/v1/showcase/${showcase_id}`);
    return handleResponse(collection);
  }
}

export async function getCollections(
  store_id: number
) {
  if (store_id > 0 && !isNaN(store_id)) {
    const collections = await axios.get(`${SERVER_HOST}/api/v1/showcase?store_id=${store_id}&ordering=0&skip=0&limit=10`);
    return handleResponse(collections);
  }
}

export async function getCollectionProducts(
  collectionId: number = null,
  orderingOn: string = null,
  skip: number = 0,
  limit: number = 10,
) {
  const products = await axios.get(`${SERVER_HOST}/api/v1/showcase/items?${collectionId ? `showcase_id=${collectionId}&` : ''}${orderingOn ? `ordering_on=${orderingOn}&` : ''}skip=${skip}&limit=${limit}`);
  return handleResponse(products);
}
